var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',{staticClass:"flex-div"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('vue-phone-number-input',{attrs:{"default-country-code":'DK',"hide-details":"","translations":{
                  countrySelectorLabel: 'Landekode',
                  countrySelectorError: 'Ukendt landekode',
                  phoneNumberLabel: 'Telefonnummer',
                  example: 'Eksempel: '
                }},on:{"update":_vm.save},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }